import { render, staticRenderFns } from "./SelectionMare.vue?vue&type=template&id=023508cb&"
import script from "./SelectionMare.vue?vue&type=script&lang=js&"
export * from "./SelectionMare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports